import React, { Fragment, useEffect, useState } from 'react';

const DatabaseReset = ({ is_admin }) => {

    const [filter_date, setFilter_date] = useState("")

    const [dates, setDates] = useState([])
    const [display, setDisplay] = useState([])


    function filter() {
        try {
            setDisplay(dates.filter(date => {
                var pass = true;
                if (filter_date !== "") {
                    if (!date.toLowerCase().includes(filter_date.toLocaleLowerCase())) {
                        pass = false
                    }
                }
                return pass;
            }))
        } catch (err) {
            console.error("Couldn't filter all DB resets")
            console.error(err.message)
        }
    }

    const getBackups = async () => {
        const response = await fetch("https://www.beyondcommunityaccess.com/database/", {
            method: "GET",
            headers: { "Content-Type": "application/json", token: localStorage.token },
        })

        var jsonRes = await response.json();

        setDates(jsonRes)
        setDisplay(jsonRes)
    }
    useEffect(() => {
        getBackups()
    }, [])

    useEffect(() => {
        filter()
    }, [filter_date])

    return (
        <div className="container">
            <Fragment>
                <h1>Reset DB</h1>
                <h6>Here, you can 'rewind' the database to the midnight morning of any given day</h6>
                <p>Be aware this doesn't change history. For example if you restore the database image from the 20th, then the logs for the 21st onwards would still show what they were. This could result in cases where a databse on, say, the 25th actually has LESS information than the database backup on the 24th shows, and the server traffic logs will seem confusing.</p>
                <p className="text-danger">Basically, don't do this unless really necessary</p>
                <p>Inform a member of the IT team and they will do this for you</p>
                <h3>Here is a list of possible backups, select one</h3>
                <input className="form-control m-1" type="text" placeholder="Date" value={filter_date} onChange={e => setFilter_date(e.target.value)} />
                {display.map((reset, index) => (
                    <p key={index} className="">Date: {reset}</p>
                ))}
            </Fragment>
        </div >
    );
}

export default DatabaseReset;

